import { FlowOutputBlockConfigSchema } from 'flow-schema';
import { z } from 'zod';

import {
  BaseFlowBlockSchema,
  BlockType,
  ProducedType,
  returnTypeSchema,
} from '../base/baseSchema.js';

export const OutputBlockSchema = BaseFlowBlockSchema.extend({
  type: z.literal(BlockType.Output),
  config: FlowOutputBlockConfigSchema,
  returnType: returnTypeSchema(ProducedType.Any),
});

export type OutputBlock = z.infer<typeof OutputBlockSchema>;
